export class TermsOfUse{
    id:number;
    version:number; 
    termsOfUseText:string;
    publishedBy:string;
    publishedOn:string;

}


// WEBPACK FOOTER //
// ./src/app/modules/terms-of-use/entity/terms-of-use.ts